import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  value:"选中tab的值",
  fontFamily: "字体",
  hoverFontFamily: "hover字体",
  fontSize: "字体大小",
  hoverFontSize: "hover字体大小",
  fontWeight: "字重",
  hoverFontWeight: "hover字重",
  color: "字体颜色",
  textIsThemeColor: "字体颜色跟随主题色",
  hoverColor: "hover字体颜色",
  hoverTextIsThemeColor: "hover字体颜色跟随主题色",
  bgColor: "背景颜色",
  hoverBgColor: "hover背景颜色",
  lineHeight: "行高",
  hoverLineHeight: "hover行高",
  letterSpacing: "字间距",
  hoverLetterSpacing: "hover字间距",
  fontStyle: "字体样式",
  hoverFontStyle: "hover字体样式",
  textAlign: "对齐方式",
  hoverTextAlign: "hover对齐方式",
  writingMode: "排列方式",
  hoverWritingMode: "hover排列方式",
  textDecoration: "下划线",
  hoverTextDecoration: "hover下划线",
  textIndent: "文本缩进",
  hoverTextIndent: "hover文本缩进",
  maxLength: "tab最大长度",
  borderTopLeftRadius: "左上角圆角",
  borderTopRightRadius: "右上角圆角",
  borderBottomLeftRadius: "左下角圆角",
  borderBottomRightRadius: "右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色跟随主题色",
  hoverBorderColor: "hover边框颜色",
  hoverBorderStyle: "hover边框类型",
  hoverBorderWidth: "hover边框宽度",
  hoverBorderIsThemeColor: "hover时边框是否跟随主题色",
  tabWidth: "tab宽度",
  tabHeight: "tab高度",
  tabBackgroundColor: "tab背景色",
  tabMarginRight: "tab右间距",
  activeIndex: "tab选中项索引",
  hoverUnderlineStyle: "hover下划线类型",
  hoverUnderlineColor: "hover下划线颜色",
  hoverUnderlineWidth: "hover下划线宽度",
  bgColorIsThemeColor: "hover下划线是否跟随主题色",
  hoverBgColorIsThemeColor: "hover背景是否跟随主题色",
  opacity: "透明度",
  bgType: "背景颜色类型",
  allBgColor: "全局背景颜色",
  bgStartColor: "背景渐变色开始色值",
  bgEndColor: "背景渐变色结束色值",
  oxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  allBorderTopLeftRadius: "全局左上角圆角",
  allBorderTopRightRadius: "全局右上角圆角",
  allBorderBottomLeftRadius: "全局左下角圆角",
  allBorderBottomRightRadius: "全局右下角圆角",
  allBorderStyle: "全局边框类型", // solid dashed dotted
  allBorderColor: "全局边框颜色",
  allBorderWidth: "全局边框宽度",
  allBorderIsThemeColor: "全局边框颜色跟随主题色",
  contentHasLimit: "是否开启字数限制",
  textLimitLines: "字数限制个数",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
}
export const getOptDes = toSelectOpt.bind(this, optDes)
